// Dependencies
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get COMPANY_FUNCTION_KEYS () {
        return COMPANY_FUNCTION_KEYS;
    },
    get COMPANY_FUNCTION_VALUES () {
        return COMPANY_FUNCTION_VALUES;
    },
    get COMPANY_HOME_BOOLEAN_SETTING_KEYS () {
        return COMPANY_HOME_BOOLEAN_SETTING_KEYS;
    },
    get COMPANY_HOME_LEGACY_SCALAR_SETTING_KEYS () {
        return COMPANY_HOME_LEGACY_SCALAR_SETTING_KEYS;
    },
    get COMPANY_PREFERRED_NAVIGATION_VALUES () {
        return COMPANY_PREFERRED_NAVIGATION_VALUES;
    },
    get CalendarIntegrationSettingsSchema () {
        return CalendarIntegrationSettingsSchema;
    },
    get CompanyBillingSettingsModel () {
        return CompanyBillingSettingsModel;
    },
    get CompanyLinkModel () {
        return CompanyLinkModel;
    },
    get CompanyModel () {
        return CompanyModel;
    },
    get CompensationSettingsSchema () {
        return CompensationSettingsSchema;
    },
    get LEGACY_NAMED_COLORS () {
        return LEGACY_NAMED_COLORS;
    },
    get SideNavCustomThemeSchema () {
        return SideNavCustomThemeSchema;
    },
    get VideoConferencingSettingsSchema () {
        return VideoConferencingSettingsSchema;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _ai = require("./ai");
const _companyhierarchy = require("./company-hierarchy");
const _engagement = require("./engagement");
const _featureflag = require("./feature-flag");
const _stripe = require("./stripe");
const CalendarIntegrationSettingsSchema = _zod.z.object({
    enabled: _zod.z.boolean()
});
const VideoConferencingSettingsSchema = _zod.z.object({
    enabled: _zod.z.boolean()
});
const CompensationSettingsSchema = _zod.z.object({
    cycle_owners: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)).default([]),
    total_salary: _zod.z.number().default(0),
    total_salary_updated_at: _zod.z.date().optional()
});
const FeatureFlagValueSchema = _zod.z.string().or(_zod.z.number()).or(_zod.z.boolean());
const FeatureFlagRecordSchema = _zod.z.object(Object.fromEntries(_featureflag.FLAG_SLUGS.map((slug)=>[
        slug,
        FeatureFlagValueSchema
    ])));
const COMPANY_FUNCTION_KEYS = [
    "workflows",
    "reviews",
    "easy_add",
    "goals",
    "goal-dashboard",
    "resources",
    "directory",
    "org-chart",
    "groups",
    "doc-signing",
    "feedback",
    "saml",
    "hr-integration",
    "enforce-login-methods",
    "slack-notifications",
    "teams-integration",
    "teams-user-notifications",
    "integration-sftp",
    "reporting-visualization",
    "scim_api",
    "managers-can-view-report-analytics-feature"
];
const COMPANY_FUNCTION_VALUES = [
    "enabled",
    "disabled",
    "hidden",
    "adp-wfn",
    "adp-vantage",
    "bamboohr",
    "netchex",
    "gusto",
    "rippling",
    "ukg-pro"
];
const COMPANY_HOME_BOOLEAN_SETTING_KEYS = [
    "manager-reassign",
    "chain-of-command-create-review",
    "managers-can-view-report-analytics",
    "contributors-can-view-report-analytics",
    "group-admins-can-view-report-analytics",
    "add-360-form-button-label"
];
const COMPANY_HOME_LEGACY_SCALAR_SETTING_KEYS = [
    "defaultTimezone",
    "defaultReviewStartTime",
    "defaultReviewCycleDueTime",
    "decimalPlaces"
];
const COMPANY_PREFERRED_NAVIGATION_VALUES = [
    "classic",
    "new"
];
const SideNavCustomThemeSchema = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    name: _zod.z.string().min(1).max(50),
    background_color: _zod.z.string().regex(/^#[0-9A-F]{6}$/)
});
const LEGACY_NAMED_COLORS = [
    "aliceblue",
    "antiquewhite",
    "aqua",
    "aquamarine",
    "azure",
    "beige",
    "bisque",
    "black",
    "blanchedalmond",
    "blue",
    "blueviolet",
    "brown",
    "burlywood",
    "cadetblue",
    "chartreuse",
    "chocolate",
    "coral",
    "cornflowerblue",
    "cornsilk",
    "crimson",
    "cyan",
    "darkblue",
    "darkcyan",
    "darkgoldenrod",
    "darkgray",
    "darkgreen",
    "darkkhaki",
    "darkmagenta",
    "darkolivegreen",
    "darkorange",
    "darkorchid",
    "darkred",
    "darksalmon",
    "darkseagreen",
    "darkslateblue",
    "darkslategray",
    "darkturquoise",
    "darkviolet",
    "deeppink",
    "deepskyblue",
    "dimgray",
    "dodgerblue",
    "firebrick",
    "floralwhite",
    "forestgreen",
    "fuchsia",
    "gainsboro",
    "ghostwhite",
    "gold",
    "goldenrod",
    "gray",
    "green",
    "greenyellow",
    "honeydew",
    "hotpink",
    "indianred",
    "indigo",
    "ivory",
    "khaki",
    "lavender",
    "lavenderblush",
    "lawngreen",
    "lemonchiffon",
    "lightblue",
    "lightcoral",
    "lightcyan",
    "lightgoldenrodyellow",
    "lightgray",
    "lightgreen",
    "lightgrey",
    "lightpink",
    "lightsalmon",
    "lightseagreen",
    "lightskyblue",
    "lightslategray",
    "lightsteelblue",
    "lightyellow",
    "lime",
    "limegreen",
    "linen",
    "magenta",
    "maroon",
    "mediumaquamarine",
    "mediumblue",
    "mediumorchid",
    "mediumpurple",
    "mediumseagreen",
    "mediumslateblue",
    "mediumspringgreen",
    "mediumturquoise",
    "mediumvioletred",
    "midnightblue",
    "mintcream",
    "mistyrose",
    "moccasin",
    "navajowhite",
    "navy",
    "oldlace",
    "olive",
    "olivedrab",
    "orange",
    "orangered",
    "orchid",
    "palegoldenrod",
    "palegreen",
    "paleturquoise",
    "palevioletred",
    "papayawhip",
    "peachpuff",
    "peru",
    "pink",
    "plum",
    "powderblue",
    "purple",
    "red",
    "rosybrown",
    "royalblue",
    "saddlebrown",
    "salmon",
    "sandybrown",
    "seagreen",
    "seashell",
    "sienna",
    "silver",
    "skyblue",
    "slateblue",
    "slategray",
    "snow",
    "springgreen",
    "steelblue",
    "tan",
    "teal",
    "thistle",
    "tomato",
    "turquoise",
    "violet",
    "wheat",
    "white",
    "whitesmoke",
    "yellow",
    "yellowgreen"
];
const AuthenticationSettingsSchema = _zod.z.object({
    authentication_methods: _zod.z.record(_zod.z.string(), _zod.z.object({
        state: _zod.z.enum([
            "enabled",
            "disabled"
        ])
    })).optional(),
    ip_whitelist_settings: _zod.z.object({
        enforced_state: _zod.z.enum([
            "open",
            "enforce"
        ])
    }).optional()
}).catchall(_zod.z.any());
const CompanyModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    activation_status: _zod.z.string(),
    active_users: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)),
    admins: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)),
    billing_admins: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)),
    billing_expires: _zod.z.date(),
    bor_required: _zod.z.boolean(),
    custom_billing: _zod.z.boolean(),
    custom_branding: _zod.z.boolean(),
    expires: _zod.z.date(),
    functions: _zod.z.record(_zod.z.string(), _zod.z.any()),
    icon_color: _zod.z.string().optional(),
    max_doc_space: _zod.z.number(),
    max_users: _zod.z.number(),
    name: _zod.z.string(),
    nav_color: _zod.z.string().optional(),
    price_per_user: _zod.z.number(),
    review_forms: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)).optional(),
    review_workflows: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)).optional(),
    stripe_customer_info: _stripe.StripeCustomerModel.optional(),
    workflow_templates: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)),
    signature_request_templates: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)).optional(),
    settings: _zod.z.record(_zod.z.string(), _zod.z.union([
        _zod.z.boolean(),
        _zod.z.number(),
        _zod.z.string()
    ])).optional(),
    aggregation_tables: _zod.z.object({
        review_assignments: _zod.z.object({
            last_update: _zod.z.date(),
            building: _zod.z.boolean()
        })
    }).optional(),
    has_tree: _zod.z.boolean().optional(),
    needs_recompute: _zod.z.boolean().optional(),
    computing_tree: _zod.z.boolean().optional(),
    hierarchy_groups: _companyhierarchy.HierarchyGroupsSchema.optional(),
    basic_admins: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)).optional(),
    implementation_date: _zod.z.date().optional(),
    authentication_settings: AuthenticationSettingsSchema.optional(),
    notifications: _zod.z.record(_zod.z.string(), _zod.z.any()),
    default_timezone: _zod.z.string().optional(),
    job_statuses: _zod.z.object({
        invites_resent: _zod.z.date()
    }).optional(),
    public_api: _zod.z.object({
        created_at: _zod.z.date(),
        usage_plan_id: _zod.z.string(),
        updated_at: _zod.z.date().optional()
    }).optional(),
    engagement: _engagement.EngagementSettingsSchema.optional(),
    ai: _ai.AiSettingsSchema.optional(),
    calendar_integration: CalendarIntegrationSettingsSchema.optional(),
    video_conferencing: VideoConferencingSettingsSchema.optional(),
    compensation: CompensationSettingsSchema.optional(),
    feature_flag: FeatureFlagRecordSchema.partial().optional(),
    licenses: _zod.z.array(_zod.z.string()).optional(),
    decimal_places: _zod.z.number().optional(),
    max_doc_spaces: _zod.z.number().optional(),
    next_invoice: _zod.z.object({
        price: _zod.z.number(),
        seats: _zod.z.number(),
        start: _zod.z.date(),
        end: _zod.z.date(),
        unit_price: _zod.z.number(),
        frequency: _zod.z.string(),
        terms: _zod.z.string()
    }).optional(),
    min_users_to_add: _zod.z.number().optional(),
    preferred_navigation: _zod.z.enum(COMPANY_PREFERRED_NAVIGATION_VALUES).optional(),
    side_nav_themes: _zod.z.array(SideNavCustomThemeSchema).optional(),
    selected_side_nav_theme_id: _zod.z.string().optional(),
    org_chart_fields: _zod.z.array(_zod.z.union([
        _zod.z.instanceof(_bson.ObjectId),
        _zod.z.string()
    ])).optional(),
    tax_address: _zod.z.object({
        company_code: _zod.z.string().optional(),
        address_line_1: _zod.z.string().optional(),
        zip: _zod.z.string().optional(),
        address_line_2: _zod.z.string().optional(),
        has_tax_exclusion: _zod.z.boolean().default(false)
    }).optional()
});
const CompanyLinkModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    adder: _zod.z.instanceof(_bson.ObjectId),
    company: _zod.z.instanceof(_bson.ObjectId),
    description: _zod.z.string(),
    score: _zod.z.number(),
    title: _zod.z.string(),
    url: _zod.z.string()
});
const CompanyBillingSettingsModel = CompanyModel.pick({
    _id: true,
    name: true,
    billing_admins: true,
    next_invoice: true,
    billing_expires: true,
    price_per_user: true,
    stripe_customer_info: true,
    min_users_to_add: true,
    max_users: true,
    tax_address: true
});
